export default __webpack_public_path__ + "static/media/iconApprove.d7e45fbf.svg";